import { render, staticRenderFns } from "./FormAdminData.vue?vue&type=template&id=077929a2&"
import script from "./FormAdminData.vue?vue&type=script&lang=js&"
export * from "./FormAdminData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports